var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrashOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 5L4.64564 15.9758C4.77037 18.0962 4.83273 19.1564 5.28528 19.961C5.68366 20.6692 6.28832 21.2394 7.01876 21.5955C7.84851 22 8.91054 22 11.0346 22H12.9654C15.0895 22 16.1515 22 16.9812 21.5955C17.7117 21.2394 18.3163 20.6692 18.7147 19.961C19.1673 19.1564 19.2296 18.0962 19.3544 15.9758L20 5M4 5H2M4 5H20M20 5H22M16 5L15.547 3.64105C15.3503 3.05094 15.252 2.75588 15.0695 2.53774C14.9084 2.3451 14.7016 2.19599 14.4679 2.10408C14.2032 2 13.8922 2 13.2702 2H10.7298C10.1078 2 9.79677 2 9.53213 2.10408C9.29844 2.19599 9.09156 2.3451 8.93047 2.53774C8.74804 2.75588 8.64969 3.05094 8.45298 3.64105L8 5",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashOutline);
export default __webpack_public_path__ + "static/media/trash-outline.b5291d27a28b4304362e4aba90336fdb.svg";
export { ForwardRef as ReactComponent };